module.exports = __webpack_public_path__ + "static/img/fullScreen.6d91df1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/fullScreen.png
// module id = 7QDs
// module chunks = 0